import FullScreenCard from '../../shared/FullScreenCard';
import { useContext, useEffect, useState } from 'react';
import { fetchGet } from '../../../utils/fetch';
import Table from '../../shared/Table';
import GeneralContext from '../../../context/GeneralContext';

function UsersPoints() {

    const { setUserAdminHistoryId, setUserAdminHistoryName, changeCurrentMenu } = useContext(GeneralContext);

    const [headers, setHeaders] = useState([
        {id: 'header0', text: 'Alerta'}
    ]);

    const [activeUsersList, setActiveUsersList] = useState([
        {id: '1a', fields: [
            {id: '0', text: 'Error conectándose al servidor'}
          ]
        }
    ]);

    const [tableType, setTableType] = useState('display');

    const prepareUserList = (list) => {
        setHeaders([
            {id: 'header0', text: 'Nombre'},
            {id: 'header1', text: 'Documento'},
            {id: 'header2', text: 'Rol'},
            {id: 'header3', text: 'Puntos'}
        ]);
        const newList = [];
        for (let i = 0; i < list.length; i++) {
            if (list[i].status === 'active') {
                let role = '';
                if (list[i].role === 'user') {role = 'Usuario'};
                if (list[i].role === 'admin') {role = 'Administrador'};
                if (list[i].role === 'super_admin') {role = 'Súper Administrador'};
                const item = {
                    id: list[i].id,
                    fields: [
                        {id: '0', text: list[i].last_name + ' ' + list[i].first_name},
                        {id: '1', text: list[i].document},
                        {id: '2', text: role},
                        {id: '3', text: list[i].points}
                    ]
                }
                newList.push(item);
            }
        }
        setActiveUsersList(newList);
        setTableType('actions');
    }

    useEffect(() => {
        const getUsersList = async () => {
            const response = await fetchGet('');
            if (response.success) {
                prepareUserList(response.list);
            }
        }
        getUsersList();
    }, []);

    const goToAdminPointsHistory = (id, item) => {;
        setUserAdminHistoryId(id);
        setUserAdminHistoryName(item[0].text);
        changeCurrentMenu('admin-history-points');
    }

    const userHistoryActions = [{
        id: 0,
        text: 'Ver historial',
        buttonFunction: goToAdminPointsHistory
    }]

    
  return (
    <FullScreenCard hasBackNavigation={true} backNavigationFunction={changeCurrentMenu} backNavigationTarget={'manage-points'}>
        <h1>Historial de Puntos por Usuario</h1>
        <Table
            headers={headers}
            data={activeUsersList}
            type={tableType}
            actions={userHistoryActions}
        />
    </FullScreenCard>
  )
}

export default UsersPoints